<template>
  <nav
    :class="{sidebar: true, sidebarStatic, sidebarOpened}"
    @mouseenter="sidebarMouseEnter"
    @mouseleave="sidebarMouseLeave"
  >
    <header class="logo">
      <router-link to="/app">
        <span class="text-warning">Web</span>Duka
      </router-link>
    </header>
    <ul class="nav">
      <NavLink
        header="Dashboard"
        link="/app/dashboard"
        iconName="flaticon-home"
        index="dashboard"
        isHeader
      />
      <NavLink
        :activeItem="activeItem"
        header="Sale"
        link="/app/sales"
        iconName="flaticon-network"
        index="sales"
        :childrenLinks="[
          { header: 'Cash Sale - POS', link: '/app/sales/cashsale' },
          { header: 'Credit Note', link: '/app/sales/creditnote' },
          { header: 'Customer', link: '/app/sales/customers' },
          /*{ header: 'Customer Category', link: '/app/sales/customercategory' },
          { header: 'Customer Enquiry', link: '/app/sales/customerenquiry' },
          { header: 'Posting Category', link: '/app/sales/customerpostingcategory' },*/
          { header: 'Customer Quotes', link: '/app/sales/customerquotes' },
          { header: 'Delivery Notes', link: '/app/sales/deliverynotes' },
          { header: 'Online Sales', link: '/app/sales/onlinesales' },
          { header: 'Sale Invoice', link: '/app/sales/saleinvoice' },
          { header: 'Sale Settings', link: '/app/sales/salesettings' },
        ]"
      />
      <NavLink
        :activeItem="activeItem"
        header="Inventory"
        link="/app/invetory"
        iconName="flaticon-network"
        index="invetory"
        :childrenLinks="[
          { header: 'Branch Order', link: '/app/invetory/branchorder' },
          { header: 'Branch Receipt', link: '/app/invetory/branchreceipt' },
          { header: 'Branch Transfer', link: '/app/invetory/branchtransfer' },
          { header: 'Stock', link: '/app/invetory/stock' },
          { header: 'Inventory Journal', link: '/app/invetory/inventoryjournal' },
          { header: 'Item Group', link: '/app/invetory/itemgroup' },
          { header: 'Manufacturer', link: '/app/invetory/manufacturer' },
          { header: 'Stock Enquiry', link: '/app/invetory/stockenquiry' },
          { header: 'Stock Taking', link: '/app/invetory/stocktaking' },
        ]"
      />
      <NavLink
        :activeItem="activeItem"
        header="Accounting"
        link="/app/accounting"
        iconName="flaticon-network"
        index="accounting"
        :childrenLinks="[
          { header: 'Account', link: '/app/accounting/account' },
          { header: 'Journal Entry', link: '/app/accounting/journalentry' },
          { header: 'Payment', link: '/app/accounting/payment' },
          { header: 'Payment Method', link: '/app/accounting/paymentmethod' },
          { header: 'Receipt', link: '/app/accounting/receipt' },
          { header: 'Tax Type', link: '/app/accounting/taxtype' },
        ]"
      />
      <NavLink
        :activeItem="activeItem"
        header="Suppliers"
        link="/app/suppliers"
        iconName="flaticon-network"
        index="suppliers"
        :childrenLinks="[
          { header: 'Goods Received', link: '/app/suppliers/goodsreceived' },
          { header: 'Goods Returned', link: '/app/suppliers/goodsreturned' },
          { header: 'Purchase Order', link: '/app/suppliers/purchaseorder' },
          { header: 'Supplier', link: '/app/suppliers/supplier' },
          { header: 'Supplier Enquiry', link: '/app/suppliers/supplierenquiry' },
          { header: 'Supplier Invoice', link: '/app/suppliers/supplierinvoice' },
        ]"
      />
      <NavLink
        :activeItem="activeItem"
        header="Reports"
        link="/app/reports"
        iconName="flaticon-network"
        index="reports"
        :childrenLinks="[
          { header: 'System Report', link: '/app/reports/systemreport' },
          { header: 'Report Group', link: '/app/reports/reportgroup' },
        ]"
      />
      <NavLink
        :activeItem="activeItem"
        header="System"
        link="/app/system"
        iconName="flaticon-network"
        index="system"
        :childrenLinks="[
          { header: 'Alert', link: '/app/system/alerts' },
          { header: 'Alert Type', link: '/app/system/alerttype' },
          { header: 'Branch', link: '/app/system/branch' },
          { header: 'Locations', link: '/app/system/location' },
          { header: 'Role', link: '/app/system/roles' },
          { header: 'Special Permissions', link: '/app/system/specialpermission' },
          { header: 'System Settings', link: '/app/system/systemsettings' },
          { header: 'User', link: '/app/system/users' },
        ]"
      />
    </ul>
    <p></p>
  </nav>
</template>

<script>
import { mapState, mapActions } from "vuex";
import isScreen from "@/core/screenHelper";
import NavLink from "./NavLink/NavLink";

export default {
  name: "Sidebar",
  components: { NavLink },
  data() {
    return {};
  },
  methods: {
    ...mapActions("layout", ["changeSidebarActive", "switchSidebar"]),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split("/");
      paths.pop();
      this.changeSidebarActive(paths.join("/"));
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    }
  },
  created() {
    this.setActiveByRoute();
  },
  computed: {
    ...mapState("layout", {
      sidebarStatic: state => state.sidebarStatic,
      sidebarOpened: state => !state.sidebarClose,
      activeItem: state => state.sidebarActiveElement
    })
  }
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>
